@let mapCenter = mapCenter$ | async; @let mapOptions = mapOptions$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="{{defaultBackHref}}/profile/{{profileId}}"></ion-back-button>
    </ion-buttons>
    <ion-title>Map View</ion-title>
  </ion-toolbar>
</red-header-content>
<ion-content color="light">
  @if (mapOptions && mapCenter) {
  <google-map
    height="100%"
    width="100%"
    [center]="mapCenter"
    [options]="mapOptions"
    (mapInitialized)="mapInitialized($event)"
  >
    <red-user-position></red-user-position>

    @if (showMarker) { @let markerOptions = markerOptions$ | async; @if (markerOptions) {
    <map-marker [position]="mapCenter" [options]="markerOptions"></map-marker>
    } @else {
    <map-marker [position]="mapCenter"></map-marker>
    } }
  </google-map>
  }
  <div class="tw:absolute tw:top-0 tw:w-full">
    <red-map-default-options>
      <ion-fab-button (click)="centerOnPin()" color="light" size="small">
        <ion-icon src="/assets/svg/target.svg"></ion-icon>
      </ion-fab-button>
      <ion-fab-button (click)="togglePinVisibility()" color="{{showMarker ? 'primary' : 'light'}}" size="small">
        <ion-icon src="/assets/svg/pin.svg"></ion-icon>
      </ion-fab-button>
    </red-map-default-options>
  </div>
</ion-content>
